<template>
	<div style="width:100%;height:100px;">
		<div class="logoNav">
			<!-- 左侧logo -->
      <span style="font-size: 26px;font-weight: bold;color: #0848cd;margin-top: 40px;display: inline-block;">医疗器械领域数据库</span>

<!--			<img src="../../assets/img/weigaoLogo.png" width="200" style="margin-top:30px;">-->
			<!-- 搜索框 -->
			<!-- <img src="../../assets/img/home/homeTopSearchTest.png" style="position: relative;left:260px;top:15px;"> -->
			<div class="searchInput float-right">
				<div>
					  <div class="mt-3">
					    <el-input
					      v-model="searchKeyValue"
					      placeholder="请输入您要查找的内容"
					      class="input-with-select logoInput"
						  style="border: 1px solid #C32A1A;width:534px;"
						  size="large"
						  @keyup.enter.native="searchValue"
					    >
					      <template #prepend>
							<div class="logoLeftSelect">
								<el-select v-model="select" placeholder="" style="width: 110px;background-color: #fff;height:40px;">
								  <el-option label="专利" value="patent"/>
								  <el-option label="商标" value="brand"/>
								</el-select>
							</div>
					      </template>
					      <template #append>
					        <div class="rightFont" @click="searchValue">
								<span>搜索</span>
							</div>
					      </template>
					    </el-input>
					  </div>
				</div>
			</div>
			<!-- 右侧小图标 -->
			<img src="../../assets/img/home/head-bg.png" style="position: absolute;right: 0;bottom: 0;" width="450">
			<!-- <img src="../../assets/img/home/homelogoHeadRight.png"> -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				select:'patent',
				searchKeyValue:''
			}
		},
		methods: {
			searchValue() {
				let vm = this
				if(vm.searchKeyValue == ''){
					return alert('请输入要搜索的条件')
				}
				vm.$router.push({
					path:'/searchPage',
					query:{
						type:vm.select,
						keyValue:vm.searchKeyValue
					}
				})
			}
		},
	}
</script>

<style scoped>
	/* logo及导航栏 */
	.logoNav {
		width: 1200px;
		height: 100px;
		margin: 0 auto;
		position: relative;
		bottom: 8px;
	}
	.searchInput{
		position: relative;
		right: 250px;
		top: 20px;
		z-index: 99;
	}
	.rightFont{
		background-color: #C32A1A;
		width:98px;
		height: 40px;
		line-height: 40px;
		font-size:16px;
		color: #fff;
		text-align: center;
		cursor: pointer;
	}
</style>
<style>
	.el-input-group__append{
		padding: 0 !important;
		border: none;
	}
	.logoInput .el-input__inner{
		border: none !important;
	}
	.logoLeftSelect .el-input__inner{
		padding-left:27px;
		font-size:16px;
		color: #C32A1A !important;
	}
</style>
